module.exports = __webpack_public_path__ + "static/media/2.b9d68e7b.jpg";